import logo from './img/logo.png';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid, regular, brands, icon } from '@fortawesome/fontawesome-svg-core/import.macro'

const Download = () => {
  return (
    <div className="App">
      <header className="App-header">
        <h1><FontAwesomeIcon icon={solid('download')} /> Diamond Client Download</h1>
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Click the button below to download the client!
        </p>
        <a
          className="download"
          href="https://github.com/ProKocak28/diamondclient-assets/releases/latest" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <button className='download-button'><FontAwesomeIcon className='download-button-icon' icon={solid('download')} /> Download Diamond Client Now!</button>
        </a>
      </header>
    </div>
  );
}

export default Download;
